export default {
  get_all: { method: "get", url: "api/tipos-concedentes" },
  show: { method: "get", url: "api/tipos-concedentes{/id}" },
  store: { method: "post", url: "api/tipos-concedentes" },
  update: { method: "put", url: "api/tipos-concedentes{/id}" },
  delete: { method: "delete", url: "api/tipos-concedentes{/id}" }
};
